import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResolveFn, Router } from '@angular/router';
import { MobileDeviceWarningComponent } from '@components/dialogs/mobile-device-warning/mobile-device-warning.component';
import { Store } from '@ngrx/store';
import { DeviceDetectionService } from '@shared/services/device-detection.service';
import { authState, authActions } from '@sleipai/sleip-ngrx-store';
import { of } from 'rxjs';

export const restrictAccessToMobileDevicesResolver: ResolveFn<boolean> = () => {
  const router = inject(Router);
  const dialog = inject(MatDialog);
  const store = inject(Store<authState.State>);

  const deviceDetection = inject(DeviceDetectionService);

  if (deviceDetection.isMobileDevice()) {
    dialog.open(MobileDeviceWarningComponent, {
      height: '230px',
      width: '343px',
      disableClose: true,
      panelClass: 'mobile-device-warning-modal-panel',
    });
    store.dispatch(authActions.logoutUser(false));
    router.navigate(['']);
    return of(false);
  } else {
    return of(true);
  }
};
